import { v4 as uuidv4 } from 'uuid';

/**
 * Fills the days array with blank days up to `upToIndex`. This prevents crashes
 * when a row reads `${dayIndex}.experienceId` off a day that does not exist.
 */
export function prefillDays(days, upToIndex) {
  const newDays = days ?? [];

  for (let i = 0; i < upToIndex; i++) {
    if (!newDays[i]) {
      newDays[i] = {
        dayIndex: i + 1,
        id: uuidv4(),
        experienceId: null,
        hotelId: null,
        experienceDayIndex: null,
        experiencePricing: null,
        hotelPricing: null,
        hotelBookedOnMyOwn: false,
        selectedExtras: [],
      };
    }
  }

  return newDays;
}
